import React from 'react';
import classnames from 'classnames';


function ResumeFormButton(props) {
  const { isWizardStarted, className, onAct } = props;
  return (
    <div
      className={classnames("gp-resume-form-button", props.className)}
      onClick={props.onAct}
    >
      <span>
        {isWizardStarted ? 'Continuer mon témoignage' : 'Ajouter mon témoignage'}
      </span>
    </div>
  );
}

export default ResumeFormButton;
